import React from "react";
import PropTypes from "prop-types";
import EnabledFeaturesContext from "../../context/enabledFeaturesContext";

const BehindFeatureFlag = props => (
  <EnabledFeaturesContext.Consumer>
    {features =>
      features.some(f => f.toLowerCase() === props.feature.toLowerCase())
        ? props.children
        : props.fallback || null
    }
  </EnabledFeaturesContext.Consumer>
);

BehindFeatureFlag.propTypes = {
  feature: PropTypes.string.isRequired
};

export default BehindFeatureFlag;
